module.exports = __webpack_public_path__ + "static/img/banner.6c57b6bb.png";